import NotFound from '@/components/NotFound'
import SecondaryPageLayout from '@/layouts/SecondaryPageLayout'
import { forwardRef, useEffect } from 'react'
import { useTranslation } from 'react-i18next'

const NotFoundPage = forwardRef(({ index }: { index?: number }, ref) => {
  const { t } = useTranslation()

  useEffect(() => {
    document.title = t('Not Found | {{appName}}', { appName: window.hallway.universe.appName })
    history.replaceState(null, '')
  }, [])
  return (
    <SecondaryPageLayout ref={ref} index={index} hideBackButton title="">
      <NotFound />
    </SecondaryPageLayout>
  )
})
NotFoundPage.displayName = 'NotFoundPage'
export default NotFoundPage
